export default "__VITE_ASSET__33935f11__"